import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { AbsoluteSpinner, ButtonWithText, Logo } from '../App/Components'
import { StyledScrollView } from '../App/Components/AppContainer'
import { useHistory, useParams } from '../Router'

import { OverviewHeader } from './Components'
import { ICustomer } from './store/interface/IAppointmentState'
import { useAppSelector } from '../store/hooks'

export const Appointment = () => {
  const { establishmentId } = useParams<{ [key: string]: string }>()
  const history = useHistory()
  const { t } = useTranslation()

  const { settingsState, appointment } = useAppSelector((state) => ({
    appointment: state.appointment,
    settingsState: state.settings,
  }))

  useEffect(() => {
    if (!appointment) {
      return
    }

    //TODO update this cusumer logic so that it is not living in a random component
    const currentCustomer: ICustomer =
      appointment.customers[appointment.currentCustomerIndex]
    if (
      typeof currentCustomer === 'undefined' ||
      currentCustomer.activities?.length === 0
    ) {
      if (settingsState.values?.locations?.length === 1) {
        history.push(`/${establishmentId}`)
      } else if (
        settingsState.values?.locations?.length &&
        settingsState.values?.locations?.length > 1
      ) {
        if (settingsState.values?.isMenuVisible) {
          history.push(`/${establishmentId}/menu`)
        } else {
          history.push(`/${establishmentId}/activities`)
        }
      }
    }
  }, [appointment, settingsState, establishmentId, history])

  if (typeof settingsState.values === 'undefined' || !appointment) {
    return <AbsoluteSpinner />
  }

  const { backgroundColor, highlightColor } = settingsState.values

  return (
    <StyledScrollView autoScroll>
      <Logo />
      <OverviewHeader
        settingsState={settingsState}
        establishmentId={establishmentId}
      />
      <ButtonWithText
        backgroundcolor={backgroundColor}
        fontcolor={highlightColor}
        hoversensitive
        onPress={() =>
          history.push(`/${establishmentId}/appointment/date`)
        }
      >
        {t('Next')}
      </ButtonWithText>
    </StyledScrollView>
  )
}
